import { render, staticRenderFns } from "./CustomerMemo.vue?vue&type=template&id=a7bf752e"
import script from "./CustomerMemo.vue?vue&type=script&lang=js"
export * from "./CustomerMemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports